exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reports{border-radius:5px;background-color:#fff}.reports hr{margin:0}.reports .pagination-body{padding-left:15px}.reports .reports-body{padding:10px 25px}.reports .reports-body .event{margin-bottom:15px}.reports .reports-body .reports-reload{padding-top:15px;padding-bottom:25px}.reports .reports-body .popover-image{width:150px}.reports .reports-body .popover-image img{width:100%}.reports .reports-body .clickable{cursor:pointer}.reports>h4{padding:15px 25px;margin:0}.nav-pills{margin-bottom:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/reports.component/styles.less
 ** module id = 619
 ** module chunks = 0
 **/